export const neurons = [
  // ─── EMPLOYMENT (Frontal Lobe) ───────────────────────────────────────────
  {
    id: 'job-khora',
    label: 'Khora Therapeutics',
    type: 'employment',
    region: 'career',
    importance: 10,
    description:
      'Full-stack Software Engineer at a cutting-edge therapeutics startup. Responsible for frontend design and architecture, backend services, database design, and cloud infrastructure on AWS. Bridging deep science with modern web engineering.',
    dates: '2025–present',
    tags: ['React', 'AWS', 'Full-Stack', 'Design', 'TypeScript', 'PostgreSQL'],
    url: null,
    hasPage: true,
    role: 'Software Engineer 1',
    tech: ['React', 'TypeScript', 'AWS', 'PostgreSQL', 'Node.js', 'Python'],
    achievements: [
      'Owned frontend architecture and design system from the ground up',
      'Designed and built backend APIs and database schemas',
      'Deployed and maintained cloud infrastructure on AWS',
      'Bridged biotech domain expertise with modern software engineering',
    ],
  },
  {
    id: 'job-shepherd',
    label: 'SHEPHERD Therapeutics',
    type: 'employment',
    region: 'career',
    importance: 9,
    description:
      'Software Engineer at a therapeutics company, building internal tools and data platforms. Developed a strong foundation in biotech-focused software engineering.',
    dates: '2024–2025',
    tags: ['Software Engineering', 'Biotech', 'React', 'Python'],
    url: null,
    hasPage: true,
    role: 'Software Engineer 1',
    tech: ['React', 'Python', 'SQL'],
    achievements: [
      'Built and maintained internal data tools for research teams',
      'Developed expertise in biotech software workflows',
    ],
  },
  {
    id: 'job-lyra',
    label: 'Lyra Therapeutics',
    type: 'employment',
    region: 'career',
    importance: 9,
    description:
      'Area lead engineer driving GMP clinical manufacturing and process development for multiple pipeline products. Operated in ISO 7 and ISO 8 cleanroom environments. Authored and reviewed GMP documents as a subject matter expert, and managed deviations, CAPAs, and change controls.',
    dates: '2020–2023',
    tags: ['GMP', 'Process Development', 'Cleanroom', 'Regulatory', 'CMO', 'CAPA'],
    url: null,
    hasPage: true,
    role: 'Engineer I',
    tech: ['AutoCAD', 'SolidWorks', 'Empower', 'HPLC'],
    achievements: [
      'Advanced GMP clinical manufacturing as area lead engineer across multiple pipeline products',
      'Coordinated with CMO partners to develop procedures and scale processes',
      'Led equipment qualifications in ISO 7 and ISO 8 cleanrooms',
      'Authored GMP manufacturing documents as subject matter expert',
      'Initiated and closed deviations, CAPAs, and change controls to strengthen process controls',
    ],
  },
  {
    id: 'job-liquiglide',
    label: 'LiquiGlide',
    type: 'employment',
    region: 'career',
    importance: 6,
    description:
      'Independently developed a coating formulation project at a fast-moving biotech startup. Designed experiments, collected data, and co-authored an official SOP and a first-author conference poster for an implantable device project.',
    dates: 'Jul–Dec 2019',
    tags: ['Coating', 'R&D', 'Startup', 'Implantable Devices', 'SOP'],
    url: null,
    hasPage: true,
    role: 'Biomedical Engineer Co-op',
    tech: ['Lab analytics', 'SOP authoring', 'Goniometer', 'Particle sizing'],
    achievements: [
      'Developed coating formulation project from concept to completion over 4 months',
      'Pioneered methods for new implantable device projects in a startup environment',
      'Contributed as first author to a conference research poster attracting new clientele',
    ],
  },
  {
    id: 'job-ocular',
    label: 'Ocular Therapeutix',
    type: 'employment',
    region: 'career',
    importance: 6,
    description:
      'Analytical Chemistry co-op working on medical device and pharmaceutical products across the full development pipeline. Completed independent analytical method development for USP testing and participated in an FDA audit.',
    dates: 'Jul–Dec 2018',
    tags: ['Analytical Chemistry', 'HPLC', 'USP Testing', 'FDA', 'Pharma'],
    url: null,
    hasPage: true,
    role: 'Analytical Chemistry Co-op',
    tech: ['HPLC/UPLC', 'FTIR', 'UV-Vis', 'Karl Fischer', 'Empower'],
    achievements: [
      'Completed analytical method development for USP testing for two products independently',
      'Worked through a full FDA audit and device/pharmaceutical approval process',
      'Gained hands-on experience across all stages of the development pipeline',
    ],
  },
  {
    id: 'job-actionlab',
    label: 'Action Lab @ NU',
    type: 'employment',
    region: 'career',
    importance: 5,
    description:
      'Biomedical robotics research assistant studying how the human brain controls the muscular system during complex movements. Built mathematical models and ran experiments to track brain–muscle interactions.',
    dates: 'Jan–May 2019',
    tags: ['Robotics', 'Neuroscience', 'MATLAB', 'Research', 'Biomechanics'],
    url: null,
    hasPage: true,
    role: 'Biomedical Robotics Research Assistant',
    tech: ['MATLAB', 'Laser optics', 'SEM', 'Compound microscopy'],
    achievements: [
      'Formulated and simulated mathematical models of complex human movements',
      'Designed and ran experiments tracking brain–muscle interactions',
    ],
  },

  // ─── PROJECTS (Parietal Lobe) ────────────────────────────────────────────
  {
    id: 'proj-neural-portfolio',
    label: 'Neural Portfolio',
    type: 'project',
    region: 'projects',
    importance: 9,
    description:
      'This site — a full-viewport interactive brain/neural network visualization built with React, D3 force simulation, and Framer Motion. Each node in the visualization represents a career milestone, skill, or personal interest.',
    dates: '2026',
    tags: ['React', 'D3', 'Framer Motion', 'Data Viz', 'Personal'],
    url: null,
    hasPage: true,
    role: 'Creator',
    tech: ['React 19', 'D3 v7', 'Framer Motion 11', 'CSS animations', 'Canvas2D'],
    achievements: [
      'Full-viewport D3 force simulation with 30+ neurons clustered into brain regions',
      'Animated synapse threads with stroke-dashoffset flow effects',
      'Framer Motion detail panel with spring animation',
      'Canvas2D particle field background',
    ],
  },
  {
    id: 'proj-biotech-dashboard',
    label: 'Biotech Dashboard',
    type: 'project',
    region: 'projects',
    importance: 7,
    description:
      'Internal data visualization platform for research and operations teams, enabling real-time tracking of experimental data and manufacturing metrics.',
    dates: '2024–2025',
    tags: ['React', 'Data Viz', 'Internal Tools', 'Biotech'],
    url: null,
    hasPage: true,
    role: 'Lead Engineer',
    tech: ['React', 'TypeScript', 'Python', 'PostgreSQL', 'AWS'],
    achievements: [
      'Designed and built interactive dashboards for research teams',
      'Integrated real-time data streams from laboratory systems',
    ],
  },
  {
    id: 'proj-coating-research',
    label: 'Coating Formulation',
    type: 'project',
    region: 'projects',
    importance: 6,
    description:
      'Independent research project developing a novel coating formulation for implantable medical devices. Included full method development, experimental design, and co-authorship of a conference poster.',
    dates: '2019',
    tags: ['Research', 'Implantable Devices', 'Coating', 'Method Development'],
    url: null,
    hasPage: true,
    role: 'First Author / Researcher',
    tech: ['Goniometer', 'Particle sizing', 'SOP authoring', 'Lab analytics'],
    achievements: [
      'Pioneered a complete coating formulation from scratch',
      'Presented findings at a major scientific conference as first author',
    ],
  },
  {
    id: 'proj-gmp-process',
    label: 'GMP Process Ops',
    type: 'project',
    region: 'projects',
    importance: 5,
    description:
      'Process improvement initiative at Lyra Therapeutics to tighten manufacturing controls through systematic deviation analysis, CAPA management, and equipment qualification protocols.',
    dates: '2020–2023',
    tags: ['GMP', 'CAPA', 'Process Improvement', 'ISO', 'Quality'],
    url: null,
    hasPage: true,
    role: 'Area Lead Engineer',
    tech: ['AutoCAD', 'SolidWorks', 'Empower', 'Cleanroom equipment'],
    achievements: [
      'Led equipment qualifications in ISO 7/8 cleanrooms',
      'Closed multiple CAPAs and change controls to improve process reliability',
    ],
  },

  // ─── TECHNICAL SKILLS (Left Temporal) ───────────────────────────────────
  {
    id: 'skill-react',
    label: 'React / JS',
    type: 'skill',
    region: 'skills',
    importance: 7,
    description: 'Primary frontend framework. React 19, hooks, context, React Router, and component architecture.',
    dates: '2023–present',
    tags: ['React', 'JavaScript', 'TypeScript', 'Hooks'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-python',
    label: 'Python',
    type: 'skill',
    region: 'skills',
    importance: 6,
    description: 'Data processing, scripting, backend services, and scientific computing. Used across biotech and software roles.',
    dates: '2017–present',
    tags: ['Python', 'Data', 'Scripting', 'Backend'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-matlab',
    label: 'MATLAB',
    type: 'skill',
    region: 'skills',
    importance: 5,
    description: 'Mathematical modeling and simulation of biomechanical systems. Used extensively in Action Lab research.',
    dates: '2018–2021',
    tags: ['MATLAB', 'Simulation', 'Math Modeling', 'Research'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-aws',
    label: 'AWS',
    type: 'skill',
    region: 'skills',
    importance: 6,
    description: 'Cloud infrastructure, deployment, and managed services on Amazon Web Services.',
    dates: '2024–present',
    tags: ['AWS', 'Cloud', 'Infrastructure', 'DevOps'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-hplc',
    label: 'HPLC / UPLC',
    type: 'skill',
    region: 'skills',
    importance: 5,
    description: 'High-performance liquid chromatography for analytical method development and USP testing in pharma/biotech environments.',
    dates: '2018–2023',
    tags: ['HPLC', 'Analytical', 'Pharma', 'Lab'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-gmp',
    label: 'GMP Manufacturing',
    type: 'skill',
    region: 'skills',
    importance: 7,
    description: 'Good Manufacturing Practice — clinical manufacturing, cleanroom operations, deviation management, and regulatory documentation.',
    dates: '2020–2023',
    tags: ['GMP', 'Cleanroom', 'Regulatory', 'ISO 7', 'ISO 8'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-solidworks',
    label: 'SolidWorks / CAD',
    type: 'skill',
    region: 'skills',
    importance: 4,
    description: 'SolidWorks and AutoCAD for engineering design, equipment documentation, and process layouts.',
    dates: '2018–2023',
    tags: ['SolidWorks', 'AutoCAD', 'CAD', 'Engineering'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-analytical-chem',
    label: 'Analytical Chem',
    type: 'skill',
    region: 'skills',
    importance: 5,
    description: 'Full suite of analytical chemistry techniques: FTIR, UV-Vis, Karl Fischer, fluorometry, goniometry, particle sizing, and SEM.',
    dates: '2018–2023',
    tags: ['FTIR', 'UV-Vis', 'SEM', 'Fluorometry', 'Lab'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-cplusplus',
    label: 'C++ / Java',
    type: 'skill',
    region: 'skills',
    importance: 3,
    description: 'Systems programming and object-oriented development studied at Northeastern.',
    dates: '2016–2021',
    tags: ['C++', 'Java', 'OOP', 'Systems'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },

  // ─── SOFT SKILLS (Right Temporal) ────────────────────────────────────────
  {
    id: 'skill-regulatory',
    label: 'Regulatory Affairs',
    type: 'skill',
    region: 'skills',
    importance: 6,
    description: 'Navigating FDA audits, CAPA management, change controls, and GMP documentation in regulated pharma/biotech environments.',
    dates: '2018–2023',
    tags: ['FDA', 'CAPA', 'Change Control', 'Compliance'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-tech-writing',
    label: 'Technical Writing',
    type: 'skill',
    region: 'skills',
    importance: 5,
    description: 'Authored and reviewed GMP manufacturing documents, SOPs, and research posters as a subject matter expert.',
    dates: '2018–2023',
    tags: ['GMP Docs', 'SOPs', 'Research', 'Communication'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-cross-functional',
    label: 'Cross-Functional',
    type: 'skill',
    region: 'skills',
    importance: 5,
    description: 'Coordinating across clinical, manufacturing, quality, and engineering teams to drive shared outcomes.',
    dates: '2020–present',
    tags: ['Collaboration', 'Leadership', 'Teams', 'Communication'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-startup',
    label: 'Startup Adaptability',
    type: 'skill',
    region: 'skills',
    importance: 4,
    description: 'Thriving in fast-moving startup environments — LiquiGlide, SHEPHERD, Khora — where initiative and speed matter.',
    dates: '2019–present',
    tags: ['Startup', 'Adaptability', 'Initiative', 'Autonomy'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-process-eng',
    label: 'Process Engineering',
    type: 'skill',
    region: 'skills',
    importance: 6,
    description: 'Designing, qualifying, and optimizing manufacturing and lab processes across biotech environments.',
    dates: '2020–2023',
    tags: ['Process Design', 'Qualification', 'Optimization', 'Engineering'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'skill-behavioral-neuroscience',
    label: 'Behavioral Neuroscience',
    type: 'skill',
    region: 'career',
    importance: 7,
    description: 'Minor in Behavioral Neuroscience from Northeastern, combined with hands-on brain–muscle research at the Action Lab. Informs the neural metaphor underlying this portfolio itself.',
    dates: '2016–2021',
    tags: ['Neuroscience', 'Behavior', 'Brain', 'Research', 'Academic'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },

  // ─── EDUCATION (Occipital Lobe) ───────────────────────────────────────────
  {
    id: 'edu-northeastern',
    label: 'Northeastern University',
    type: 'education',
    region: 'personal',
    importance: 8,
    description:
      'Bachelor of Science in Bioengineering with a minor in Behavioral Neuroscience. GPA 3.48. Co-op program produced six months of real-world biotech industry experience before graduation.',
    dates: '2016–2021',
    tags: ['Bioengineering', 'Behavioral Neuroscience', 'Co-op', 'B.S.'],
    url: null,
    hasPage: false,
    role: 'B.S. Bioengineering',
    tech: [],
    achievements: [
      'Graduated with 3.48 GPA',
      'Minor in Behavioral Neuroscience',
      'Completed multiple co-ops through Northeastern\'s experiential learning program',
    ],
  },
  {
    id: 'edu-thessaloniki',
    label: 'Study Abroad — Greece',
    type: 'education',
    region: 'personal',
    importance: 4,
    description:
      'Semester abroad at the American College of Thessaloniki through Northeastern\'s N.U.in program. Immersive cultural and academic experience in northern Greece.',
    dates: 'Fall 2016',
    tags: ['Study Abroad', 'Greece', 'N.U.in', 'International'],
    url: null,
    hasPage: false,
    role: 'Study Abroad Participant',
    tech: [],
    achievements: [],
  },

  // ─── PERSONAL (Cerebellum) ───────────────────────────────────────────────
  {
    id: 'personal-watches',
    label: 'Watches & Models',
    type: 'personal',
    region: 'personal',
    importance: 4,
    description: 'Collecting, building, and restoring watches, timepieces, and mechanical models. Appreciation for precision engineering at small scales.',
    dates: 'Ongoing',
    tags: ['Horology', 'Collecting', 'Engineering', 'Craft'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'personal-music',
    label: 'Music',
    type: 'personal',
    region: 'personal',
    importance: 4,
    description: 'Playing guitar, ukulele, and piano. Music as creative outlet and counterbalance to technical work.',
    dates: 'Ongoing',
    tags: ['Guitar', 'Ukulele', 'Piano', 'Music'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'personal-cooking',
    label: 'Cooking',
    type: 'personal',
    region: 'personal',
    importance: 3,
    description: 'Exploring cuisines and cooking techniques — chemistry in the kitchen.',
    dates: 'Ongoing',
    tags: ['Cooking', 'Food', 'Chemistry', 'Creativity'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'personal-sports',
    label: 'Sports',
    type: 'personal',
    region: 'personal',
    importance: 4,
    description: 'Soccer, tennis, swimming, basketball — team and individual sports for fitness and fun.',
    dates: 'Ongoing',
    tags: ['Soccer', 'Tennis', 'Swimming', 'Basketball'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
  {
    id: 'personal-travel',
    label: 'Travel',
    type: 'personal',
    region: 'personal',
    importance: 3,
    description: 'Exploring new countries and cultures. Shaped by time living in Thessaloniki, Greece.',
    dates: 'Ongoing',
    tags: ['Travel', 'Culture', 'International', 'Greece'],
    url: null,
    hasPage: false,
    role: null,
    tech: [],
    achievements: [],
  },
];
